export function loadGoogleAnalytics() {
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

  ga('create', GA_GTAG_ID, 'auto');
  ga('send', 'pageview');
}

export function getAccountSegment(compositeFleetSize) {
  if (window.isVSBAndLowerSMBToSMBEnabled && window.isVSBAndLowerSMBToSMBEnabled()) {
    if (compositeFleetSize >= 1 && compositeFleetSize <= 24) return 'SMB';  
  }

  if (compositeFleetSize >= 1 && compositeFleetSize <= 4) return 'VSB';
  else if (compositeFleetSize >= 5 && compositeFleetSize <= 24) return 'Lower SMB';
  else if (compositeFleetSize >= 25 && compositeFleetSize <= 99) return 'Upper SMB';
  else if (compositeFleetSize >= 100 && compositeFleetSize <= 749) return 'MM';
  else if (compositeFleetSize >= 750) return 'ENT';
  else return '0'; // in case compositeFleetSize is zero
}

function isGaLoaded() {
  return typeof window.ga === 'function';
}

export function setDimensions(session) {
  if (!isGaLoaded()) return;

  const compositeFleetSize = session.getCompanyProperty('composite_fleet_size') || '';
  ga('set', {
    dimension1: (session.getCompanyProperty('id') || '').toString(),
    dimension2: compositeFleetSize.toString(),
    dimension3: getAccountSegment(compositeFleetSize),
    dimension4: session.getCompanyProperty('sf_account_status') || '',
    dimension5: session.getCompanyProperty('subscription_plan') || '',
    dimension6: session.getCompanyProperty('compliance_mode') || '',
    dimension7: session.getCompanyProperty('cycle') || '',
    dimension8: session.getTotalElds().toString(),
    dimension9: session.getUserId().toString(),
    dimension10: session.getUserCycle(),
    dimension11: session.getUserRole(),
    dimension12: session.getUser().created_at,
  });
}

export function trackPageView(path) {
  if (!isGaLoaded()) return;

  ga('set', 'page', path);
  ga('send', 'pageview');
}
